export const debugCard = ({
    'number': '4915669353237603',
    'name': 'Hector Mauricio Muñoz Fonseca',
    'exp_year': '26',
    'exp_month': '12',
    'cvc': '221',
    'phone': '6129034821',
    'email': 'hector.munoz@talisis.com',
    "card_expiration": "12/26"
});
